import React from "react";
import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";

type StickyCtaBarProps = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  mobile?: React.ReactNode;
};

const StickyCtaBar = ({ left, right, mobile }: StickyCtaBarProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("tablet"));

  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        width: "100%",
        zIndex: theme.zIndex.appBar,
        backgroundColor: theme.colors.neutral.white,
        borderTop: `1px solid ${theme.colors.neutral.lightGray}`,
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <Box
        sx={{
          maxWidth: theme.breakpoints.values.desktop,
          margin: "0 auto",
          padding: theme.spacing(2),
        }}
      >
        {isMobile ? (
          mobile
        ) : (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            {left ? (
              <Stack direction="row" spacing={theme.spacing(3)}>
                {left}
              </Stack>
            ) : (
              <span />
            )}

            {right ? (
              <Stack direction="row" spacing={theme.spacing(2)}>
                {right}
              </Stack>
            ) : null}
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default StickyCtaBar;
